<template>
    <div>
        <div class="mt-n20px mt-md-n40px mb-20px">
            <div class="d-flex justify-center pa-12px py-md-16px">
                <v-checkbox ref="all" :input-value="user._terms.length == termsList.length" label="전체 이용약관에 동의합니다." hide-details @click.stop="all" class="ma-0 pa-0 font-weight-bold"/>
            </div>
            <v-divider/>
        </div>

        <div>
            <div v-for="(terms, index) in termsList" :key="terms._id" :class="{ 'mt-40px mt-md-60px': !!index }">
                <v-layout no-gutters align-center>
                    <span><b>{{ `${terms.subject} ${terms.required ? "(필수)" : "(선택)"}` }}</b></span>
                    <v-spacer/>
                    <v-checkbox v-model="user._terms" :value="terms._id" label="동의" hide-details multiple class="mt-0"/>
                </v-layout>
                <v-sheet width="100%" height="2" color="primary" class="mt-3"/>
                <v-sheet v-bind="$attrs" outlined hide-details max-height="200" class="overflow-auto pa-4">
                    <p v-html="terms?.content" />
                </v-sheet>
            </div>

            <div class="mt-20px mt-md-40px">
                <v-row align="center" justify="center" class="row--small">
                    <v-col cols="auto">
                        <v-btn x-large width="120" color="primary" @click="next()">동의</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn x-large width="120" color="primary" outlined to="/">동의안함</v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    props: ["value", "step"],
    data(){
        return {
            user: this.$props.value,

            termsList: []
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { termsList } = await api.v1.terms.gets({ headers: { limit: 0 } });
            this.termsList = termsList;
        },
        all(){
            let all = this.termsList.length == this.user._terms.length;
            this.user._terms = all ? [] : this.termsList.map(terms => terms._id);
        },
        input(){

        },
        validate(){
            try{
                for(let terms of this.termsList){
                    if(terms.required && !this.user._terms.includes(terms._id)) throw new Error(`[${terms.subject}] 에 동의해주세요`);
                }
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        next(){
            if(this.validate()){
                this.$emit("next");
            }
        }
    },
    watch: {
        user: {
            deep: true,
            handler(value){
                this.$emit("input", value);
            }
        }
    }
}
</script>